export const sessionStorage = {
  set: (key, value) => window.sessionStorage.setItem(`np@${key}`, value),
  get: key => window.sessionStorage.getItem(`np@${key}`),
}
